import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InfoPointProperties } from '../../../span-progress-entities';

@Component({
  selector: 'app-info-point-popup-content',
  template: `
    <div>
      <div class="infoPopup-item">
        <strong>{{ 'infoPopup.name' | translate }}:</strong>
        {{ properties.name }}
      </div>
      @if (properties.description) {
        <div class="infoPopup-item">
          <strong>{{ 'infoPopup.description' | translate }}:</strong>
          {{ properties.description }}
        </div>
      }
      @if (properties.freeText) {
        <div class="infoPopup-item">
          <strong>{{ 'infoPopup.freeText' | translate }}:</strong>
          {{ properties.freeText }}
        </div>
      }
      <div class="close-button">
        <gc-button
          [variant]="'secondary'"
          [size]="'full'"
          (clicked)="onClosePopup()"
        >
          {{ 'close' | translate }}
        </gc-button>
      </div>
    </div>
  `,
  styles: [
    `
      .infoPopup-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding-bottom: 5px;
      }

      .infoPopup-item {
        display: flex;
        flex-direction: column;
        gap: 3px;
        white-space: pre-line;
      }

      .close-button {
        margin-top: 10px;
      }
    `,
  ],
  standalone: false,
})
export class InfoPopupContentComponent {
  @Input() properties: InfoPointProperties;
  @Output() dismiss = new EventEmitter();

  onClosePopup() {
    this.dismiss.emit();
  }
}
